<app-page-header
  title="Familienmitglieder verwalten"
  subtitle="Verwalten Sie die Konten Ihrer Familienmitglieder"
  icon="people"
  [actions]="headerActions"
  variant="gradient">
</app-page-header>

<div class="nlc-container">
  <!-- Child Customers (Parent Management) -->
  <div class="nlc-manage-employees-table-card nlc-card">
    <h3 style="margin-bottom: 16px;">Familienmitglieder</h3>
    <table class="nlc-manage-employees-table">
      <thead>
        <tr class="nlc-table-header-row">
          <th class="global-table-header-cell">Name</th>
          <th class="global-table-header-cell">E-Mail</th>
          <th class="global-table-header-cell">Status</th>
          <th class="global-table-header-cell">Aktionen</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let child of childCustomers$ | async" class="nlc-table-row">
          <td class="global-table-cell">{{ child.userDetails?.firstName }} {{ child.userDetails?.lastName }}</td>
          <td class="global-table-cell">{{ child.userDetails?.email || 'Noch nicht registriert' }}</td>
          <td class="global-table-cell">
            <span [class]="child.pending ? 'status-pending' : (child.isActive ? 'status-active' : 'status-inactive')">
              {{ child.pending ? 'Ausstehend' : (child.isActive ? 'Aktiv' : 'Deaktiviert') }}
            </span>
          </td>
          <td class="global-table-cell">
            <button *ngIf="child.pending" 
                    mat-raised-button 
                    color="primary"
                    (click)="activateChild(child.id)"
                    style="margin-right: 8px;">
              <mat-icon>check</mat-icon>
              Aktivieren
            </button>
            <button *ngIf="child.isActive && !child.pending" 
                    mat-raised-button 
                    color="warn"
                    (click)="deactivateChild(child.id)">
              <mat-icon>block</mat-icon>
              Deaktivieren
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <div *ngIf="(childCustomers$ | async)?.length === 0" class="empty-state">
      Keine Familienmitglieder gefunden.
    </div>
  </div>

  <!-- Employees (Old Section - Optional, can be removed if not needed) -->
  <div class="nlc-manage-employees-table-card nlc-card" style="margin-top: 24px;" *ngIf="(employees$ | async)?.length ?? 0 > 0">
    <h3 style="margin-bottom: 16px;">Mitarbeiter</h3>
    <table class="nlc-manage-employees-table">
      <thead>
        <tr class="nlc-table-header-row">
          <th class="global-table-header-cell">Name</th>
          <th class="global-table-header-cell">E-Mail</th>
          <th class="global-table-header-cell">Status</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let employee of employees$ | async" class="nlc-table-row">
          <td class="global-table-cell">{{ employee.userDetails?.firstName }} {{ employee.userDetails?.lastName }}</td>
          <td class="global-table-cell">{{ employee.userDetails?.email }}</td>
          <td class="global-table-cell">
            <span [class]="employee.isActive ? 'status-active' : 'status-inactive'">
              {{ employee.isActive ? 'Aktiv' : 'Inaktiv' }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
